const SELECTOR = '[data-attachment-input]';

class AttachmentInput {
  constructor() {
    this.attachEventHandlers();
  }

  attachEventHandlers() {
    $('body').on('cocoon:after-insert', (event, $addedTask) => {
      if ($addedTask.find(SELECTOR).size() > 0) {
        $(document).trigger('attachment_input:initialize');
      }
    });
  }
}

export default AttachmentInput;



// WEBPACK FOOTER //
// ./src/javascripts/AttachmentInput.js